'use client';

import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';

import { buttonVariants } from './Button.variants';
import { cn } from '../../utils/cn/cn';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

const Button = ({ className, color, variant, size, type, children, ...props }: ButtonProps) => (
  <button
    {...props}
    type={type === 'submit' ? 'submit' : 'button'}
    className={cn(buttonVariants({ variant, color, size }), className)}
  >
    {children}
  </button>
);

export { Button };
